import { Component, Input } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';

import { CmsTaxonomyGeneral } from '@fcom/core-api';
import { GtmService } from '@fcom/common/gtm';
import { ElementActions, ElementTypes, GaContext } from '@fcom/common/interfaces';

import { type RibbonTheme } from '../../interfaces/destination-search.interface';

@Component({
  selector: 'fin-destination-search-campaign-ribbon',
  templateUrl: './destination-search-campaign-ribbon.component.html',
  styleUrls: ['./destination-search-campaign-ribbon.component.scss'],
  standalone: false,
})
export class DestinationSearchCampaignRibbonComponent {
  @Input()
  bookByText: string;

  @Input()
  travelPeriodText: string;

  @Input()
  termsAndConditionText: string;

  @Input()
  termsAndConditionLink: string;

  @Input()
  theme: RibbonTheme;

  readonly CmsTaxonomyGeneral = CmsTaxonomyGeneral;
  readonly SvgLibraryIcon = SvgLibraryIcon;

  constructor(private gtmService: GtmService) {}

  onLinkClick(event: Event): void {
    event.stopPropagation();

    // send the gtm track events
    this.gtmService.trackElement(
      'terms-and-conditions',
      GaContext.LANDING_PAGE,
      ElementTypes.LINK,
      null,
      ElementActions.CLICK
    );
    // open the accordion
    const elem = document.getElementsByTagName('cms-accordion')[0];
    const accordionButton = elem?.getElementsByTagName('button')[0];
    if (accordionButton && accordionButton.getAttribute('aria-expanded') === 'false') {
      accordionButton.click();
    }
  }
}
